import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

// Отправить запрос на получение меню базы знаний
export const getKnowledgebaseMenu = async () => {
  const url = `${backendUrl}/api/knowledgebase/menu/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(
        `Сетевая ошибка при получении меню базы знаний: HTTP error! Status: ${response.status}`
      );
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения меню базы знаний:', error);
    throw error;
  }
};